import { Stack, Typography } from "@mui/material";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";
import type { WorkbookTemplate } from "../../../../../api/types/workbookRuns.types";

interface Props {
  workbookTemplate: WorkbookTemplate;
}

const WorkbookTemplateDetailsPageTitle = ({ workbookTemplate }: Props) => {
  return (
    <Stack spacing={0.5} sx={{ py: 1.5, maxWidth: "700px" }}>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <TypographyTooltipEllipsis typographyProps={{ variant: "h6" }} text={workbookTemplate.name} />
      </Stack>
      <Typography variant="caption" color="textSecondary">
        Workbook Template
      </Typography>
    </Stack>
  );
};

export default WorkbookTemplateDetailsPageTitle;
